export function resolveSequenceType(cart, sessionStore) {
  const state = sessionStore.getState();
  const { preorderSequence } = state;

  if (cart?.isReturn === true || cart?.isReturn === "Y") return "regular";

  if ((cart?.layAway === "Y" || cart?.isAdvance === "Y") && preorderSequence?.prefix) {
    return "preorder";
  }

  return "regular";
}

export function generateDocumentNo(sequence) {
  if (!sequence) return null;
  const prefix = sequence.prefix || "";
  const suffix = sequence.suffix || "";
  const nextNo = (sequence.nextNo || 0) + 1;
  return `${prefix}${nextNo}${suffix}`;
}

/**
 * Reconciles the till's regular documentSequence counter at login/till-registration.
 *
 * cwrTill.nextAssignedNumber is the NEXT number the backend expects to hand out
 * (its only writer, TILL_SEQUENCE_UPDATE, does `next_assigned_number + 1` on sync
 * failure specifically to skip past the number that failed) — but documentSequence
 * is stored/used everywhere else as "the LAST number consumed" (every save site
 * computes newDocumentSequence = documentSequence + 1). Plain
 * `Math.max(serverSeq, localMax)` conflates these two conventions: whenever the
 * server value wins, treating it as "last consumed" and then adding +1 on top
 * silently burns exactly the number the backend was about to hand out. Confirmed
 * against real data — every login where serverSeq >= localMax skipped exactly
 * one number (VDP 07-17 test repro: 7 consecutive logins, 7 consecutive 1-number
 * skips, all confirmed absent both locally and server-side).
 *
 * Local max is already "last consumed" by construction (highest existing
 * documentno), so only the server side needs the -1 adjustment before comparing.
 */
export function resolveInitialDocumentSequence(serverNextAssignedNumber, localMax) {
  const serverSeq = serverNextAssignedNumber || 0;
  const serverAsLastConsumed = serverSeq > 0 ? serverSeq - 1 : 0;
  return Math.max(serverAsLastConsumed, localMax || 0);
}

export async function getLocalMaxSequence(dbAdapter, prefix) {
  if (!prefix) return 0;
  const allOrders = await dbAdapter.orders.toArray();
  let maxSeq = 0;
  for (const order of allOrders) {
    if (order.documentno?.startsWith(prefix)) {
      const seqPart = parseInt(order.documentno.slice(prefix.length), 10);
      if (!isNaN(seqPart) && seqPart > maxSeq) maxSeq = seqPart;
    }
  }
  return maxSeq;
}
